export function EducationOutlined(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.78 9.51L13.11 3.26C12.8625 3.0908 12.5698 3.00019 12.27 3H11.73C11.4302 3.00019 11.1375 3.0908 10.89 3.26L2.22 9.51C2.08232 9.60091 1.99963 9.75501 2 9.92V10.08C1.99963 10.245 2.08232 10.3991 2.22 10.49L10.89 16.74C11.1375 16.9092 11.4302 16.9998 11.73 17H12.27C12.5698 16.9998 12.8625 16.9092 13.11 16.74L20.25 11.6V20.5C20.25 20.7761 20.4739 21 20.75 21H21.5C21.7761 21 22 20.7761 22 20.5V9.92C22.0004 9.75501 21.9177 9.60091 21.78 9.51ZM12.11 15H11.9L5 10L11.93 5H12.14L19 10L12.11 15ZM9.86 18.16C10.41 18.5399 11.0616 18.7455 11.73 18.75H12.27C12.9234 18.7483 13.5612 18.5496 14.1 18.18L18 15.37V17C18 19.21 15.31 21 12 21C8.69 21 6 19.21 6 17V15.37L9.86 18.16Z"
        fill="currentColor"
      />
    </svg>
  );
}
